/**
 * @generated SignedSource<<8c3b1797e4714e11f5f38abfb324b905>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateStatementFormFragment$data = {
  readonly delegate: {
    readonly address: {
      readonly isContract: boolean;
      readonly resolvedName: {
        readonly address: string;
        readonly name: string | null;
      };
    };
    readonly statement: {
      readonly discord: string;
      readonly statement: string;
      readonly topIssues: ReadonlyArray<{
        readonly type: string;
        readonly value: string;
      }>;
      readonly topStakeholders: ReadonlyArray<{
        readonly type: string;
        readonly value: string;
      }>;
      readonly twitter: string;
    } | null;
  };
  readonly " $fragmentType": "DelegateStatementFormFragment";
};
export type DelegateStatementFormFragment$key = {
  readonly " $data"?: DelegateStatementFormFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateStatementFormFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "address"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateStatementFormFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "addressOrEnsName",
          "variableName": "address"
        }
      ],
      "concreteType": "Delegate",
      "kind": "LinkedField",
      "name": "delegate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isContract",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ResolvedName",
              "kind": "LinkedField",
              "name": "resolvedName",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DelegateStatement",
          "kind": "LinkedField",
          "name": "statement",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statement",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discord",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "twitter",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TopIssue",
              "kind": "LinkedField",
              "name": "topIssues",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TopStakeholder",
              "kind": "LinkedField",
              "name": "topStakeholders",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cac7d65966dcd46d0ee40e041ab1f430";

export default node;
